/**
 * Make the selector (navigation bar) stick to the top of the screen on scroll
 * @return {Object}
 */
module.exports = {
    navbarGuestToTop: function (selector) {
        var navbar = selector || '.navigation-guest',
            $window = jQuery(window),
            $navbar = jQuery(navbar),
            width = $(document).width() > 767 ? 132 : 80;

        $window.bind('scroll', function () {
            if ($window.scrollTop() > width) {
                $navbar.addClass('active');
            } else {
                $navbar.removeClass('active');
            }
        });
    },
};
